import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import useWrapper from '../../../hooks/useWrapper';
import { maskFunction } from '../../../util/functions';
import { Main, Content } from '../../../components/Layout'
import { Row, Col, Form } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import MenuUser from '../../../components/MenuUser';
import styleTab from '../../../components/Tab/Tab.module.css'
import styleButton from '../../../components/Button/Button.module.css'
import Wizard from '../../../components/Wizard';
import PasswordStrength from '../../../components/PasswordStrength';
import CheckboxList from '../../../components/CheckboxList';
import Slct from '../../../components/Slct'
import { ModalChangePass } from '../../../components/Modal'
import Loading from '../../../components/Loading';
import { InputDocument, Phone } from '../../../components/Input';

export default function UserRegister() {
  const { userId } = useParams();
  const navigate = useNavigate();
  const { config, me } = useWrapper();
  const [loadingPage, setLoadingPage] = useState(true)
  const [msgPassword, setMsgPassword] = useState();
  const [checkPassword, setCheckPassword] = useState('');
  const [classStrangen, setClassStrangen] = useState({
    weak: '',
    medium: '',
    strong: ''
  });

  const [checked, setChecked] = useState({ checkState: [] });
  const [checkedAttendance, setCheckedAttendance] = useState({ checkState: [] });
  const [inputDisabled, setInputDisabled] = useState(false);
  const [init, setInit] = useState(false);
  const [wizard, setWizard] = useState(1);
  const advanceStep = e => {
    let _error = [];
    document.querySelectorAll('.input-empty').forEach(e => {
      e.classList.remove('input-empty');
    })
    setTimeout(() => {
      if (e > wizard || e === "save") {
        if (!user.username) {
          _error.push({ el: "us3r.us3rnam3", wiz: 1 });
        }
        if (!user.email) {
          _error.push({ el: "us3r.3m4il", wiz: 1 });
        }
        if (!user.cell) {
          _error.push({ el: "user.cell", wiz: 1 });
        }
        if (!user.cpf) {
          _error.push({ el: "user.cpf", wiz: 1 });
        }
        if (!user.sector) {
          _error.push({ el: "user.sector", wiz: 1, parent: true });
        }
        if (!userId) {
          if (!user.password) {
            _error.push({ el: "us3r.p4ssw0rd", wiz: 1 });
          }
          if (user.password !== checkPassword) {
            _error.push({ el: "checkPassword", customText: "A confirmação de Senha está errada!", wiz: 1 });
          }
        }
        if (_error.length > 0) {
          let _custom_text_el = _error.find(el => el.customText);
          if (_custom_text_el) {
            toast.error(_custom_text_el.customText);
          }
          else {
            toast.error("Preencha todos os dados obrigatórios!");
          }
          _error.forEach(er => {
            if (er.wiz === _error[0].wiz && er.el) {
              if (er.parent) {
                document.querySelectorAll(`*[name="${er.el}"]`).forEach(el => {
                  el.parentElement.classList.add('input-empty')
                });
              }
              else {
                document.querySelectorAll(`*[name="${er.el}"]`).forEach(el => {
                  el.classList.add('input-empty');
                });
              }
            }
          })
        }
        else {
          if (e === "save") {
            let _all_selects = [];
            selected.forEach(e => {
              if (e) {
                _all_selects = _all_selects.concat(e);
              }
            });
            const data = {
              username: user.username,
              email: user.email,
              cpf: user.cpf,
              password: user.password,
              cell: user.cell,
              is_whatsapp: user.is_whatsapp,
              sector: user.sector,
              is_admin: user.is_admin,
              calendar: user.calendar,
              commercial: user.commercial,
              attendance: user.attendance,
              class: user.class,
              token: null,
              institution: user.institution,
              supplier: user.supplier,
              trainee: user.trainee,
              financial: user.financial,
              sendEmail: user.sendEmail,
              resources: _all_selects.map(e => e.value),
              attendanceResource: getCheckedInputsAttendance()
            }

            if (window.location.pathname === '/profile') {
              editContent(data, me.id);
            } else {
              if (userId) {
                editContent(data, userId);
              }
              else {
                saveContent(data);
              }
            }

          }
          else {
            setWizard(e);
          }
        }
      }
      else if (e < wizard) {
        setWizard(e);
      }
    }, 20)
  }

  const [user, setUser] = useState({
    username: '',
    email: '',
    password: '',
    cpf: '',
    cell: '',
    is_whatsapp: 0,
    sector: '',
    is_admin: 0,
    calendar: 0,
    commercial: 0,
    attendance: 0,
    class: 0,
    institution: 0,
    supplier: 0,
    trainee: 0,
    financial: 0,
    sendEmail: 0
  });

  const [allRecursosSelects, setAllRecursosSelects] = useState([])

  const [categories, setCategories] = useState()
  useEffect(() => {
    let categoriesVar = []
    api.get('categories', config)
      .then(response => {
        response.data.data.forEach(cat => {
          let eventsVar = cat.event.map(e => ({
            id: e.id,
            name: e.name,
            category_id: cat.id
          }))
          let resourcesVar = cat.resource.map(e => ({
            id: e.id,
            name: e.name,
            category_id: cat.id,
            only_attendance: e.only_attendance
          }))

          categoriesVar.push({
            id: cat.id,
            name: cat.name,
            only_attendance: cat.only_attendance,
            event: eventsVar,
            resource: resourcesVar
          })
        })
        setCategories(categoriesVar);
      })
  }, [])

  const [selected, setSelected] = useState([])
  const [resourcesDOM, setResourcesDOM] = useState()

  useEffect(() => {
    if (selected) {
      let allSelecteds = []
      selected.forEach(cat => {
        if (cat) {
          cat.forEach(rsc => {
            allSelecteds.push(rsc.value)
          })
        }
      })
      setAllRecursosSelects(allSelecteds)
    }
  }, [JSON.stringify(selected)])

  useEffect(() => {
    if (categories) {

      let resourcesVarDOM_Container = []
      let resourcesVarDOM_Categories = []

      let resourcesAttVarDOM_Container = []
      let resourcesAttVarDOM_Categories = []

      // categories.filter(e => e.only_attendance === 0)
      categories.forEach(e => {
        let resourcesOptions = e.resource.map(rsc => ({
          value: rsc.id,
          label: rsc.name
        }))
        resourcesVarDOM_Categories.push(
          <Col md={6}>
            <Form.Group>
              <span className='lince-input_label'>{e.name}</span>
              <Slct
                isMulti="true"
                options={resourcesOptions}
                placeholder="..."
                value={selected[e.id]}
                onChange={
                  o => {
                    let selectedVar = [...selected];
                    selectedVar[e.id] = o;
                    setSelected(selectedVar);
                  }
                }
              />
            </Form.Group>
          </Col>
        )
        resourcesVarDOM_Container = (
          <Row>
            {resourcesVarDOM_Categories}
          </Row>
        )
        setResourcesDOM(resourcesVarDOM_Container)
      })
    }
  }, [selected, categories])

  useEffect(() => {
    if (userId && categories) {
      let selectedVar = []
      api.get(`users/${userId}`, config)
        .then(response => {
          categories.forEach(cat => {
            selectedVar[cat.id] = cat.resource.filter(e => {
              let resources_id = response.data.resource.map(e => e.id)
              return resources_id.includes(e.id)
            })
            selectedVar[cat.id] = selectedVar[cat.id].map(e => ({
              label: e.name,
              value: e.id
            }))
          })
          setSelected(selectedVar)
        })
    }
  }, [JSON.stringify(categories)])



  useEffect(() => {
    let userToLoad
    window.location.pathname === '/profile' ? userToLoad = me.id : userToLoad = userId

    if (!!userToLoad) {
      setLoadingPage(true)
      api.get(`users/${userToLoad}`, config)
        .then(response => {
          setUser(response.data);
          let arrayResources = [];
          response.data.resource.forEach(int => {
            arrayResources[int.id] = true;
          })
          setChecked({
            ...checked,
            checkState: arrayResources
          })

          let arrayResourcesAttendance = [];

          response.data.attendanceResource.forEach(int => {
            arrayResourcesAttendance[int.id] = true;
          })
          setCheckedAttendance({
            ...checkedAttendance,
            checkState: arrayResourcesAttendance
          })
        })
        .then(() => {
          setInputDisabled(true);
          setInit(!init)
          setLoadingPage(false)
        })
    }
    else {
      setLoadingPage(false)
    }
  }, [userId, window.location.pathname])

  function getCheckedInputsAttendance() {
    let arrayCouses = []
    checkedAttendance.checkState.forEach((inst, index) => {
      if (inst === true) {
        arrayCouses.push(parseInt(index))
      }
    });

    return arrayCouses;
  }

  async function editContent(data, userId) {

    try {
      await api.put(`users/${userId}`, data, config);

      toast.success('Usuário salvo com sucesso!');
      navigate(`/users`);

    } catch (error) {
      toast.error('Falha ao salvar os dados.');
    }

  }

  async function editPassword() {
    try {
      if (user.password !== '' && user.password !== null) {
        if (user.password !== checkPassword) {
          toast.warn('As senhas não são correspondentes.');
        } else {
          await api.put(`users/${userId}`, {
            password: user.password
          }, config);

          toast.success('Conteúdo salvo com sucesso!');
          navigate(`/users`);
        }
      } else {
        toast.warn('Informe a senha.');
      }

    } catch (error) {
      toast.error('Falha ao salvar os dados.');
    }
  }

  async function saveContent(data) {

    try {
      await api.post('users', data, config);

      toast.success('Usuário salvo com sucesso!');
      navigate(`/users`);

    } catch (error) {
      toast.error('Falha ao salvar os dados.');
    }
  }

  async function deleteContent(userId) {

    try {
      await api.delete(`users/${userId}`, config);

      toast.success('Conteúdo deletado com sucesso!');
      navigate(`/users`);

    } catch (error) {
      toast.error('Falha ao deletar os dados.');
    }
  }

  const handleValueString = (event, type = null) => {
    setUser({
      ...user,
      [event.target.name]: maskFunction(event.target.value, type)
    });
  }

  const handleSlct = (e, name) => {
    setUser({
      ...user,
      [name]: e.value
    });
  }

  const handleCheckboxChangeuser = event => {
    setUser({
      ...user,
      [event.target.name]: event.target.checked
    });
  }

  const handleIsAdmin = value => {
    setUser({
      ...user,
      is_admin: value
    });
  }

  function stragenPasswordValidation(password) {
    let strength = 0;
    if (password.length < 7) {
      setClassStrangen({
        ...classStrangen,
        weak: '',
        medium: '',
        strong: ''
      });
      setMsgPassword('Mínino de 7 caracteres na senha.');
    } else {
      if (password.match(/[a-z]+/)) {
        strength += 1;
      }
      if (password.match(/[A-Z]+/)) {
        strength += 1;
      }
      if (password.match(/[0-9]+/)) {
        strength += 1;
      }
      if (password.match(/[$@#&!]+/)) {
        strength += 1;
      }

      switch (strength) {
        case 0:
          setClassStrangen({
            ...classStrangen,
            weak: 'weak',
            medium: '',
            strong: ''
          });
          setMsgPassword('Opa! Essa senha ainda está fraca. Adicione números e símbolos para deixá-a mais segura.');
          break;

        case 1:
          setClassStrangen({
            ...classStrangen,
            weak: 'weak',
            medium: '',
            strong: ''
          });
          setMsgPassword('Opa! Essa senha ainda está fraca. Adicione números e símbolos para deixá-a mais segura.');
          break;

        case 2:
          setClassStrangen({
            ...classStrangen,
            weak: 'weak',
            medium: '',
            strong: ''
          });
          setMsgPassword('Opa! Essa senha ainda está fraca. Adicione números e símbolos para deixá-a mais segura.');
          break;

        case 3:
          setClassStrangen({
            ...classStrangen,
            weak: 'weak',
            medium: 'medium',
            strong: ''
          });
          setMsgPassword('Moderada. Ainda dá pra melhorar, tente adicionar novas combinações.');
          break;

        case 4:
          setClassStrangen({
            ...classStrangen,
            weak: 'weak',
            medium: 'medium',
            strong: 'strong'
          });
          setMsgPassword('Super Senha! Agora sim, sua conta está mais segura que uma porta à 7 chaves.');
          break;

        default:
          break;
      }
    }
  }
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <Main>
      <ModalChangePass show={show} user_id={userId} onHide={handleClose} />
      <Content>
        <div>
          <Row>
            <Col lg={3}>
              <MenuUser />
            </Col>
            {!loadingPage ? (
              <Col>
                <Row className="mb-4">
                  <Col sm={6}>
                    {window.location.pathname !== '/profile' ? (
                      <h2 className="form-title">{userId ? "Editar" : "Cadastrar"} Usuário</h2>
                    ) : (
                      <h2 className="form-title">Meus Dados</h2>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="mb-3">
                      <Wizard selected={wizard} options={[
                        { label: 'Dados e Permissões', onClick: () => advanceStep(1) },
                        { label: 'Recursos e Atendimentos', onClick: () => advanceStep(2) }
                      ]} />
                    </div>
                  </Col>
                </Row>
                <div className="contentPadding flexColumn">
                  <Form id="userForm" className="mb-5">
                    {wizard === 1 ? (
                      <Row className='inner-page__sbs-border'>
                        <Col md={8}>
                          <Row>
                            <Col>
                              <Form.Group>
                                <span className='lince-input_label'>Nome Completo</span>
                                <Form.Control
                                  disabled={inputDisabled}
                                  value={user.username || ''}
                                  name="us3r.us3rnam3"
                                  onChange={e => {
                                    setUser({
                                      ...user,
                                      username: e.target.value
                                    })
                                  }}
                                  autoComplete="off"
                                />
                              </Form.Group>
                            </Col>
                            <Col>
                              <Form.Group className='lince-input'>
                                <span className='lince-input_label'>Email</span>
                                <div className='lince-input__text'>
                                  <Form.Control
                                    autoComplete="off"
                                    disabled={inputDisabled}
                                    value={user.email || ''}
                                    name="us3r.3m4il"
                                    onChange={e => {
                                      setUser({
                                        ...user,
                                        email: e.target.value
                                      })
                                    }}
                                    type='text' />
                                </div>
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <Form.Group className='lince-input'>
                                <span className='lince-input_label'>Celular</span>
                                <div className='lince-input__text'>
                                  <Phone
                                    valueChange={e => {
                                      setUser({
                                        ...user,
                                        cell: e
                                      })
                                    }}
                                    value={user.cell || ''}
                                    name="user.cell"
                                  />
                                </div>
                              </Form.Group>
                            </Col>
                            <Col>
                              <Form.Group className='lince-input'>
                                <span className='lince-input_label'>CPF</span>
                                <div className='lince-input__text'>
                                  <InputDocument
                                    valueChange={e => {
                                      setUser({
                                        ...user,
                                        cpf: e
                                      })
                                    }}
                                    type="cpf"
                                    disabled={inputDisabled}
                                    value={user.cpf || ''}
                                    name="user.cpf"
                                  />
                                </div>
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <Form.Group className="d-block">
                                <span className='lince-input_label'>Setor</span>
                                <div className='lince-input__select'>
                                  <Slct
                                    options={[{ value: 'Financeiro', label: 'Financeiro' }, { value: 'Marketing', label: 'Marketing' }, { value: 'Operacional', label: 'Operacional' }, { value: 'Diretoria', label: 'Diretoria' }, { value: 'Comercial', label: 'Comercial' }, { value: 'Designer', label: 'Designer' }]}
                                    placeholder="..."
                                    name="user.sector"
                                    value={user.sector || ''}
                                    onChange={e => {
                                      setUser({
                                        ...user,
                                        sector: e.value
                                      })
                                    }}
                                    isDisabled={inputDisabled}
                                  />
                                </div>
                              </Form.Group>
                            </Col>
                            <Col>
                              <Form.Group className='lince-input'>
                                <span className='lince-input_label'>Gerência?</span>
                                <div className={styleTab.tab}>
                                  <button type="button" onClick={() => handleIsAdmin(true)} className={user.is_admin && 'active'}>Sim</button>
                                  <button type="button" onClick={() => handleIsAdmin(false)} className={!user.is_admin && 'active'}>Não</button>
                                </div>
                              </Form.Group>
                            </Col>
                          </Row>
                          {(!userId && window.location.pathname !== '/profile') && (
                            <>
                              <Row>
                                <Col>
                                  <Form.Control type='password' style={{ position: 'absolute', left: "-9999px" }} />
                                  <Form.Group className='lince-input'>
                                    <span className='lince-input_label'>Senha de Acesso</span>
                                    <Form.Control
                                      type='password'
                                      autocomplete="off"
                                      value={user.password || ''}
                                      name="us3r.p4ssw0rd"
                                      onChange={e => {
                                        setUser({
                                          ...user,
                                          password: e.target.value
                                        })
                                        stragenPasswordValidation(e.target.value);
                                      }}
                                    />
                                  </Form.Group>
                                </Col>
                                <Col>
                                  <Form.Group className='lince-input'>
                                    <span className='lince-input_label'>Confirmar Senha</span>
                                    <div className='lince-input__text'>
                                      <Form.Control
                                        type='password'
                                        name="checkPassword"
                                        value={checkPassword || ''}
                                        onChange={e => {
                                          setCheckPassword(e.target.value);
                                        }}
                                      />
                                    </div>
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col sm={6}>
                                  <PasswordStrength password={user.password || ''} className="mt-n2" />
                                </Col>
                              </Row>
                            </>
                          )}
                          <Row className='mt-2'>
                            <Col>
                              {(userId || window.location.pathname === '/profile') && (
                                <button type="button" className={styleButton.button_clean} onClick={handleShow}>
                                  Alterar Senha
                                </button>
                              )}
                            </Col>
                          </Row>
                        </Col>
                        <Col>
                          <Row>
                            <Col>
                              <p className='lince-input_label'>Áreas de acesso</p>
                              <p className="small-label font-italic">*Usuários com permissões de atendimento e financeiro terão obrigatoriamente acesso aos dados de turmas, formandos e fornecedores.</p>
                            </Col>
                          </Row>
                          <Row>
                            <Col className='d-flex flex-column'>
                              <CheckboxList label='Calendário' name='calendar' status={user.calendar || 0} onChange={e => handleCheckboxChangeuser(e)} className={user.calendar ? 'active' : ''} colorScheme="simple" />
                              <CheckboxList label='Comercial' name='commercial' status={user.commercial || 0} onChange={e => handleCheckboxChangeuser(e)} className={user.commercial ? 'active' : ''} colorScheme="simple" />
                              <CheckboxList label='Atendimento' name='attendance' status={user.attendance || 0} onChange={e => handleCheckboxChangeuser(e)} className={user.attendance ? 'active' : ''} colorScheme="simple" />
                              <CheckboxList label='Turma' name='class' status={user.class || 0} onChange={e => handleCheckboxChangeuser(e)} className={user.class ? 'active' : ''} colorScheme="simple" />
                              <CheckboxList label='Instituições' name='institution' status={user.institution || 0} onChange={e => handleCheckboxChangeuser(e)} className={user.institution ? 'active' : ''} colorScheme="simple" />
                              <CheckboxList label='Fornecedores' name='supplier' status={user.supplier || 0} onChange={e => handleCheckboxChangeuser(e)} className={user.supplier ? 'active' : ''} colorScheme="simple" />
                              <CheckboxList label='Formandos' name='trainee' status={user.trainee || 0} onChange={e => handleCheckboxChangeuser(e)} className={user.trainee ? 'active' : ''} colorScheme="simple" />
                              <CheckboxList label='Financeiro' name='financial' status={user.financial || 0} onChange={e => handleCheckboxChangeuser(e)} className={user.financial ? 'active' : ''} colorScheme="simple" />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    )
                      :
                      wizard === 2 ? (
                        <Row>
                          {/* <h2 className="mini-title mb-2">Recursos</h2> */}
                          {/* {resourcesDOM} */}
                          {categories.map(e => (
                            <Col md={6}>
                              <Form.Group>
                                <span className='lince-input_label'>{e.name}</span>
                                <Slct
                                  isMulti="true"
                                  options={e.resource.map(e2 => ({
                                    label: e2.name,
                                    value: e2.id
                                  }))}
                                  placeholder="..."
                                  value={!!selected[e.id] ? selected[e.id] : []}
                                  onChange={
                                    o => {
                                      let selectedVar = [...selected]
                                      selectedVar[e.id] = o
                                      setSelected(selectedVar)
                                    }
                                  }
                                />
                              </Form.Group>
                            </Col>
                          ))}
                        </Row>
                      )
                        : (<></>)}
                    <Row className='inner-page__actions mt-3 lastEnd'>
                      <Col className='justify-content-between d-flex'>
                        <div className='inner-page__actions__group'>
                          {wizard > 1 && (
                            <button
                              className={styleButton.button_clean}
                              type="button"
                              onClick={() => setWizard(wizard - 1)}  >
                              Voltar
                            </button>
                          )}

                          {/* {(userId && window.location.pathname !== '/profile') && (
                          <button 
                            onClick={() => deleteContent(userId)} 
                            type="button" 
                            className={`ml-2 ${styleButton.button_ghost_error}`} >
                              Apagar
                            </button>
                        )} */}
                        </div>
                        <div className='inner-page__actions__group'>
                          {wizard < 2 && (
                            <button
                              className={styleButton.button_ghost}
                              type="button"
                              onClick={() => advanceStep(wizard + 1)} >
                              Avançar
                            </button>
                          )}
                          {wizard == 2 && (
                            <button
                              className={`ml-2 ${styleButton.button_primary}`}
                              type="button"
                              onClick={() => advanceStep("save")}
                            >
                              Salvar
                            </button>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Col>
            ) : (
              <Col>
                <Loading />
              </Col>
            )}
          </Row>
        </div>
      </Content>
    </Main>
  );
}
